import type { SessionStepDto } from '../../schemas/sessionSchemas';

// MSME Verification (Udyam) step (Udyam verification without OTP, Protean).
export function isMsmeStep(step: SessionStepDto) {
  return /msme/i.test(step.stepType) || /udyam|msme/i.test(step.displayName);
}

// Udyam registration number — canonical format UDYAM-XX-00-0000000 (the gateway's
// Udyam regex). Case-insensitive; callers uppercase before sending.
export function isValidUdyam(value: string): boolean {
  return /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/i.test(value.trim());
}
